import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AlertService, MemberBlogsService,AppService } from '../_services/index';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-member-blogs',
  templateUrl: './member-blogs.component.html',
  styles: []
})
export class MemberBlogsComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  blogList: any[] = []; // Table Data list
  closeResult: string; // Modal Close

  constructor(
              public router: Router,
              private dataService:MemberBlogsService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
            ) { }
    
  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allMemberBlog();
  }

  allMemberBlog(){
    this.loadShow();
    this.dataService.getMemberBlog()
        .pipe().subscribe(
          data => { this.blogList = data['blog'];
          //console.log(data['blog']);
          this.dtTrigger.next(); // Data Table          
          this.loadHide();
      });
   }

  memberBlogView(id) {
    this.router.navigate(['member-blogs-view/' + id]);
  }

  delete(id){
    if(confirm("Are you sure to delete")) {
      this.dataService.blogDelete(id)
          .pipe().subscribe(data =>{
            if(data['status']==200){
              this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Blog deleted successfully', true);
              this.allMemberBlog();
            }else{
              this.alertService.error('Blog error');
            }
          },error =>{
            this.alertService.error(error);
          });
        }
     }
  
  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

}
